import {
  SET_ASPERA_LIST,
} from './mutation-types'
import api from '@/api'
const state = {
  list: [],
}

const mutations = {
  [SET_ASPERA_LIST] (state, payload) {
    state.list = payload
  },
}

const actions = {
  // 引擎--查询aspera账号
  async queryAsperaAccounts ({commit}) {
    let {data, code, message, result} = await api.transmissionApi.queryAsperaAccounts()
    if (data) commit(SET_ASPERA_LIST, data)
    return {data, code, message, result}
  },
  async addOrUpdateAsperaAccounts ({dispatch}, payload) {
    let data = await api.transmissionApi.addOrUpdateAsperaAccounts(payload)
    // if (data.code === 200) dispatch('queryAsperaAccounts')
    return data
  },
  async markAccountType ({dispatch}, payload) {
    let data = await api.transmissionApi.markAccountType(payload)
    return data
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
